<template>
  <nav class="breadcrumbs" aria-label="breadcrumb">
    <ol>
      <li class="breadcrumb-item">
        <a href="/" class="breadcrumb-item-link">
          {{ $t('navigation.home') }}
        </a>
      </li>
      <li
        class="breadcrumb-item"
        v-for="breadcrumb in breadcrumbs"
        :key="breadcrumb.fullPath"
      >
        <RouterLink
          :to="{ path: breadcrumb.fullPath }"
          class="breadcrumb-item-link"
        >
          {{ breadcrumb.name }}
        </RouterLink>
      </li>
    </ol>
  </nav>
</template>

<script>
import { getRouteName, getRouteStructure } from '@/utils/routing'

/**
 * Extracts the current route and all parent routes from the Vue router and renders them as links.
 *
 * @example <Breadcrumbs />
 */
export default {
  name: 'Breadcrumbs',
  computed: {
    /**
     * Reads the path for the current route and returns an array of breadcrumbs for the current route and all parent routes.
     * @returns {Array<{name: string, path: string, fullPath: string, route: Route}>}
     */
    breadcrumbs() {
      return getRouteStructure(this.$router, this.$route)
    },
  },
  methods: { getRouteName },
}
</script>

<style lang="scss" scoped>
.breadcrumbs ol {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1em;
}

.breadcrumb-item {
  margin: 0 0.5em 0 0;
  list-style: none;
}

.breadcrumb-item:not(:last-child) + .breadcrumb-item::before {
  display: inline-block;
  padding-right: 0.5em;
  color: $gray;
  content: '/';
}

.breadcrumb-item-link {
  display: inline-block;
  color: $blue;
  text-decoration: none;
}
</style>
